import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/UI/Button';
import EditableCheckbox from 'components/UI/Input/EditableCheckbox';
function Table({
    children, data, headers, isLoading, fixedSize, tdClassName, trClassName, tdGeneralClassName, className,
    emptyMessage, customBg, containerClass, editAction, selectAction, hideHeader, thClass,
})
{
    return (
        <div className="tw-overflow-auto tw-w-full tw-max-w-full">
            {children}
            <div className={`tw-overflow-auto ${containerClass} ${customBg || 'tw-bg-white'} tw-p-2 tw-w-full tw-rounded dark:tw-bg-neutral-900 ${fixedSize ? 'tw-h-[350px]' : null}`}>
                <table className={`tw-font-default tw-text-sm tw-font-semibold tw-w-full ${className} ${customBg}`}>
                    {!hideHeader && (
                        <thead className="tw-text-base tw-h-[70px]">
                            <tr>
                                <th> </th>
                                {(headers).map((item) => (
                                    <th className={`tw-font-light tw-py-2 tw-px-4 tw-whitespace-nowrap ${thClass}`} key={item}>{item}</th>
                                ))}
                            </tr>
                        </thead>
                    )}
                    {isLoading
                        ? (
                            <tbody>
                                <tr>
                                    <td colSpan={headers.length + 1} className="tw-text-center tw-w-full">
                                        <LoadingSpinner loading />
                                    </td>
                                </tr>

                            </tbody>
                        ) : (
                            <tbody>
                                {(data).map((item, index) => (
                                    <tr key={item.id ?? item[headers[0]]} className={`hover:tw-shadow-md dark:hover:tw-shadow-md hover:tw-bg-primary-odd-hover tw-group dark:hover:tw-bg-neutral-800 ${trClassName}`}>
                                        <td className="group-hover:tw-bg-primary-hover"></td>
                                        {(headers).map((headerItem) => (
                                            <td className={`tw-h-7 tw-p-1 tw-py-2.5 dark:tw-border-gray-500 ${(tdGeneralClassName || ' tw-text-center ')} ${tdClassName[headerItem] ?? ''}`} key={`${item.id}_${headerItem}`}>
                                                {item[headerItem]}
                                            </td>
                                        ))}
                                        {editAction && (
                                            <td>
                                                <Button
                                                    icon={faEdit}
                                                    onClick={() => editAction(item)}
                                                    margin="tw-mt-0 tw-py-0 tw-px-0 tw-mx-0"
                                                    type="custom"
                                                    customBg="tw-bg-transparent tw-text-primary-default hover:tw-text-primary-hover"
                                                    className="tw-self-center"
                                                    iconClassName="tw-mr-0 tw-text-lg"
                                                />
                                            </td>
                                        )}
                                        {(selectAction) && (
                                            <td>
                                                <EditableCheckbox
                                                    labelText=""
                                                    editing
                                                    inputProps={{
                                                        onChange: (value) => selectAction(index, value),
                                                        value: item.selectValue,
                                                        path: `data.${index}.selectValue`,
                                                    }}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        )}
                </table>

                {!isLoading && data.length === 0 ? (
                    <div className="tw-w-full tw-text-center tw-py-3">
                        {emptyMessage}
                    </div>
                ) : ''}

            </div>
        </div>
    );
}

Table.defaultProps = {
    editAction: null,
    selectAction: null,
    data: null,
    headers: null,
    isLoading: false,
    fixedSize: false,
    tdClassName: {},
    emptyMessage: 'There are no results',
    containerClass: '',
    hideHeader: false,
    tdGeneralClassName: null,
};

Table.propTypes = {
    className: PropTypes.string,
    thClass: PropTypes.string,
    containerClass: PropTypes.string,
    tdClassName: PropTypes.object,
    trClassName: PropTypes.string,
    emptyMessage: PropTypes.string,
    children: PropTypes.node,
    data: PropTypes.array,
    headers: PropTypes.array,
    isLoading: PropTypes.bool,
    fixedSize: PropTypes.bool,
    customBg: PropTypes.string,
    editAction: PropTypes.func,
    selectAction: PropTypes.func,
    hideHeader: PropTypes.bool,
    tdGeneralClassName: PropTypes.string,
};

export default Table;
